// Fieldlink 404 — useful, not a redirect trap.
import { Link } from "react-router-dom";
import { SEO } from "@/lib/seo";
import { MarketingHeader } from "./SeoProductPage";
import { PublicFooter } from "../FAQ";

const POPULAR = [
  { to: "/", label: "Home" },
  { to: "/civil-construction-software-nz", label: "Civil Construction Software NZ" },
  { to: "/civil-estimating-software-nz", label: "Civil Estimating" },
  { to: "/resources", label: "Civil Hub & Calculators" },
  { to: "/pricing", label: "Pricing" },
  { to: "/blog", label: "Blog" },
];

export default function NotFound() {
  return (
    <div className="bg-[#f6f5f1] text-[#142635] min-h-screen">
      <SEO title="Page Not Found | Fieldlink NZ" description="That page doesn't exist. Find Fieldlink civil construction software, calculators and resources." path={null} noindex />
      <MarketingHeader />
      <section className="max-w-3xl mx-auto px-6 md:px-12 py-24 text-center">
        <p className="font-display font-black text-7xl text-[#a63c0b]">404</p>
        <h1 className="font-display font-black uppercase tracking-tight text-3xl mt-2">Page not found</h1>
        <p className="text-[#52616c] mt-3">That page has been backfilled. Try one of these instead:</p>
        <div className="flex flex-wrap justify-center gap-2 mt-8">
          {POPULAR.map((p) => (
            <Link key={p.to} to={p.to} className="rounded-md border border-[#cbd3d5] bg-white hover:border-[#FF5F15]/60 px-4 py-2 text-xs font-bold uppercase tracking-wider text-[#344451]" data-testid={`nf-${p.to.replace(/\//g, "") || "home"}`}>{p.label}</Link>
          ))}
        </div>
      </section>
      <PublicFooter />
    </div>
  );
}
